import React from 'react';
import styles from './MerchantProfil.module.css';

const About = ({ merchant }) => {
    const phone = merchant.number;
    const link = merchant.website;
    const insta = merchant.instaUrl;
    const facebook = merchant.facebookUrl;
    const tiktok = merchant.tiktokUrl;
    const map = `https://www.google.com/maps/dir/?api=1&destination=${merchant.latitude},${merchant.longitude}`;

    const aboutList = [
        {
            icon: '/Merchant/phone.png',
            label: 'Appeler',
            href: phone ? `tel:${phone}` : null,
        },
        {
            icon: '/Merchant/link.png',
            label: 'Site web',
            href: link ? link : null,
        },
        {
            icon: '/Merchant/instagram.png',
            label: 'Instagram',
            href: insta ? insta : null,
        },
        {
            icon: '/Merchant/tiktok.png',
            label: 'Tiktok',
            href: tiktok ? tiktok : null,
        },
        {
            icon: '/Merchant/facebook.png',
            label: 'Facebook',
            href: facebook ? facebook : null,
        },
        {
            icon: '/Merchant/address.png',
            label: 'Ouvrir sur Google Maps',
            href: map,
        },
    ];

    return (
        <div className={styles.categories}>
            <h1 className={styles.title}>À propos</h1>

            <div className={styles.menu}>
                {aboutList
                    .filter(item => item.href)
                    .map((item, index) => (
                        <a
                            key={index}
                            href={item.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.links}
                        >
                            <img className={styles.icon} src={item.icon} alt="" />
                            {item.label}
                        </a>
                    ))
                }
            </div>
            <p className={styles.address}>{merchant.address}</p>
        </div>
    );
};

export default About;
